import installationInstructions from './installationInstructions';

const thermostatCategoryContent = {
  installationInstructions
}

export { thermostatCategoryContent };
